<template>
  <div class="imageBox">
    <div style="display: flex; align-items: center; flex-direction: column;margin-bottom :2rem;padding-top: 30px;">
      <div :style="`width: ${width}px; height: 248px; background-color: #353535; border-radius: 24px;display: flex;flex-direction: column; align-items: flex-start; padding: ${padding}; justify-content: space-between;position: relative;overflow:hidden;`">
        <div style="font-size: 38px; color: #fff; line-height: 38px;">{{store.state.language == 'cn' ? '船道' : 'PowerFun'}}</div>
        <div style="font-size: 24px; color: rgba(255,255,255,0.70);">{{store.state.language == 'cn' ? '中国船道，以船入道。船道个人端App，来船道和道友们一起划船！':'PowerFun, Embarking on a Journey with Boats.Join PowerFun and row with fellow rowers!'}}</div>
        <div style="display: flex; align-items: center;z-index: 1;">
          <a href="https://powerfun.oss-cn-shanghai.aliyuncs.com/apks/PowerFunRower.release.apk" style="height: 42px; display: flex; align-items: center; justify-content: center; padding: 0 12px; color: #fff;border-radius: 8px; background-color: #e63422;font-size: 24px;line-height: 24px;" target="_blank">Android</a>
          <a href="https://apps.apple.com/us/app/%E8%88%B9%E9%81%93/id6444202305" style="height: 42px; display: flex; align-items: center; justify-content: center; padding: 0 12px; color: #fff;border-radius: 8px; background-color: #e63422;font-size: 24px;line-height: 24px;margin-left: 14px;" target="_blank">iOS</a>
          <a href="https://appgallery.huawei.com/app/detail?id=com.ZhiXingPai.PowerFunRowerHP&channelId=SHARE" style="height: 42px; display: flex; align-items: center; justify-content: center; padding: 0 12px; color: #fff;border-radius: 8px; background-color: #e63422;font-size: 24px;line-height: 24px;margin-left: 14px;" target="_blank">鸿蒙</a>
        </div>
        <img src="../assets/download/软件下载1.png" style="position: absolute; right: 0; top: 0; width: 400px; height: 248px;z-index: 0;">
      </div>
      <div :style="`width: ${width}px; height: 248px; background-color: #353535; border-radius: 24px;display: flex;flex-direction: column; align-items: flex-start; padding: ${padding}; justify-content: space-between;position: relative;margin-top: 20px; overflow:hidden;`">
        <div style="font-size: 38px; color: #fff; line-height: 38px;">{{store.state.language == 'cn' ? '功率房（船道教练版）':'PowerFun (Coach Edition)'}}</div>
        <div style="font-size: 24px; color: rgba(255,255,255,0.70);">{{store.state.language == 'cn' ? '专业的比赛模式，精准的数据展示，训练上课两不误！':"Professional race modes and precise data display. Both training and teaching can be done seamlessly!"}}</div>
        <div style="display: flex; align-items: center;z-index: 1;">
          <a href="https://powerfun.oss-cn-shanghai.aliyuncs.com/%E5%8A%9F%E7%8E%87%E6%88%BF.apk" style="height: 42px; display: flex; align-items: center; justify-content: center; padding: 0 12px; color: #fff;border-radius: 8px; background-color: #e63422;font-size: 24px;line-height: 24px;" target="_blank">Android</a>
          <a href="https://apps.apple.com/cn/app/%E5%8A%9F%E7%8E%87%E6%88%BF/id6445953541" style="height: 42px; display: flex; align-items: center; justify-content: center; padding: 0 12px; color: #fff;border-radius: 8px; background-color: #e63422;font-size: 24px;margin-left: 14px;line-height: 24px;" target="_blank">iOS</a>
        </div>
        <img src="../assets/download/软件下载2.png" style="position: absolute; right: 0; top: 0; width: 400px; height: 248px;z-index: 0;">
      </div>

      <div :style="`width: ${width}px; height: 248px; background-color: #353535; border-radius: 24px;display: flex;flex-direction: column; align-items: flex-start; padding: ${padding}; justify-content: space-between;position: relative;margin-top: 20px; overflow:hidden;`">
        <div style="font-size: 38px; color: #fff; line-height: 38px;">{{store.state.language == 'cn' ? '船道竞赛版':'PowerFun (Race Edition)'}}</div>
        <div style="font-size: 24px; color: rgba(255,255,255,0.70);">{{store.state.language == 'cn' ? '专业局域网赛事竞赛，实时数据可视化，划船竞技更智能！':"Professional LAN-based competitions with real-time data visualization make rowing competitions smarter!"}}</div>
        <div style="display: flex; align-items: center;z-index: 1;">
          <a href="https://powerfun.oss-cn-shanghai.aliyuncs.com/server/ob/%E8%88%B9%E9%81%93%E7%AB%9E%E8%B5%9B%E7%89%88.exe" style="height: 42px; display: flex; align-items: center; justify-content: center; padding: 0 12px; color: #fff;border-radius: 8px; background-color: #e63422;font-size: 24px;line-height: 24px;" target="_blank">Windows</a>
        </div>
        <a :href="pdfHref" target="_blank" style="position: absolute; top: 30px; right: 30px; display: flex; align-items: center; justify-content: center; z-index: 2; color: #fff; font-size: 18px; line-height: 17px; border: 1px solid rgba(255,255,255,1); border-radius: 8px; width: 129px; height: 42px;">
          <span style=" margin-right: 6px;">使用说明</span>
          <img src="../assets/download/Download.png" style="width: 17px; height: 17px;">
        </a>
        <img src="../assets/download/软件下载3.png" style="position: absolute; right: 0; top: 0; width: 400px; height: 248px;z-index: 0;">
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from "vue";
import { useStore } from "vuex";
const store = useStore();

const width = ref(1200)
const padding = ref('30px 34px')

const pdfBaseUrl = 'https://powerfun.oss-cn-shanghai.aliyuncs.com/server/ob/%E8%88%B9%E9%81%93%E7%AB%9E%E8%B5%9B%E7%89%88%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E.pdf'
const pdfHref = ref(`${pdfBaseUrl}?t=${Date.now()}`)

const handleResize = () => {
  const clientWidth = document.documentElement.clientWidth
  console.log(clientWidth)
  if(clientWidth < 1200){
    width.value = clientWidth -20
    padding.value = '20px'
  }else{
    width.value = 1200
    padding.value = '30px 34px'
  }
}
onMounted(() => {
  handleResize()
  window.addEventListener('resize', handleResize);
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
})
// function IOSDownload() {
//   //window.location.href = "https://itunes.apple.com/cn/app/id1411875128?mt=8";
//   //showToast('APP即将上架，敬请期待');
//   console.log(44);
//   window.location.href =
//     "https://apps.apple.com/us/app/%E8%88%B9%E9%81%93/id6444202305";
// }
// function OssDownload() {
//   window.location.href =
//     "https://powerfun.oss-cn-shanghai.aliyuncs.com/apks/PowerFunRower.release.apk";
// }
</script>
<!-- getImagePath('软件图片.png') -->
<style lang="scss" scoped>
.imageBox {
  min-height: calc(100vh - 12.125rem);
  width: 100%;
}

a {
  text-decoration: none; /* 去除下划线 */
  color: inherit; /* 继承父元素的颜色 */
}

a,a *{
  user-select: none; /* 禁止选中 */
  pointer-events: all; /* 确保链接仍然可点击 */
  cursor: pointer;
}

div{
  box-sizing: border-box;
}
</style>
